import { makeTestIds } from "@ctra/utils";

/**
 * Make test ids for game plans
 */
export const testIds = makeTestIds("gameplans", {
  entity: {
    wrapper: "wrapper",
    details: {
      wrapper: "wrapper",
      mobile: {
        wrapper: "wrapper"
      },
      desktop: {
        wrapper: "wrapper"
      }
    }
  }
});
